import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { MarketGuidelinesService } from '../market-guidelines.service';
import { PrintPdfFilesService } from '../print-pdf-files.service';
import {
  trigger,
  style,
  animate,
  transition
} from '@angular/animations';
import { number } from 'mathjs';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-market-guidelines',
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.75s ease-in', style({ opacity: 1}))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('0.25s ease-out', style({ opacity: 0 }))
            ])
        ])
    ],
    templateUrl: './market-guidelines.component.html',
    styleUrls: ['./market-guidelines.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class MarketGuidelinesComponent implements OnInit {
  marketGuideService = inject(MarketGuidelinesService);
  pdfService = inject(PrintPdfFilesService);


  @Output() parentEventTransmitter = new EventEmitter();

  filename: string = "Mareket Guideline";

  ngOnInit(): void {
  }

  generateReadablePDFFile() {
    // this.pdfService.generateNewPDF(this.filename);
  }

  passValuesToParent() {
    this.parentEventTransmitter.emit({
      stage: 5,
      values: {
        "selectedMarketType": this.marketGuideService.selectedMarketType,
        "selectedTopic": this.marketGuideService.selectedTopic,
        "overviewDescription": this.marketGuideService.overviewDescription,
        "overviewURL": this.marketGuideService.overviewURL,
      }
    })
  }

}
